import React, { useEffect, useState } from 'react';
import useToken from '../../useToken'
import { useSelector, useDispatch } from 'react-redux';
import { AreaChart, Area, XAxis, YAxis, Legend, Label } from 'recharts';
import blue from '@material-ui/core/colors/blue';
import { fetchAll } from '../../features/irrigation_report/irrigationAllSlice';
import { startOfWeek, addDays, format } from "date-fns";
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  title: {
    marginLeft: 10,
  },
});

export default function Water() {
  const classes = useStyles();
  const {token, setToken} = useToken()
  const dispatch = useDispatch()
  const report = useSelector((state: any) => state.irrigation_all.reportData);

    useEffect(() => {
      dispatch(fetchAll({token}))
    }, [dispatch]);

  return (
    <React.Fragment>
    <Typography variant="h6" className={classes.title}>
      Water Consumption (Liter)
    </Typography>
        <AreaChart
          height={270}
          width={300}
          data={report.data}
          margin={{
            top: 20,
            right: 5,
            bottom: 10,
            left: 5,
          }}
        >
          <XAxis dataKey="Date"/>
          <YAxis/>
          <Area type="monotone" label="Liter" dataKey="Total" barSize={30} fill={blue[500]} unit="L"/>

        </AreaChart>
    </React.Fragment>
  );
}
